import { t } from './translate'
const config = require('config');

export function getPwdError(password, confirm) {
  if (confirm.length > 0 && password.length < 8) {
    return t('Your password must be at least 8 characters long');
  }
  if (password != confirm) {
    return t('Your passwords do not match')
  }
  return false
}

export function validateEmail(email) {
  const format = /\S+@\S+\.\S+/;
  return format.test(email);
}

export function getColSize(element) {
  if (!element) return 2;
  return element.col_sm ? element.col_sm : 2;
}

export function getPaymentProvider(paymentHistoryData, defaultProvider = config.default.payment_provider) {
  if (
    paymentHistoryData &&
    paymentHistoryData.payments &&
    Array.isArray(paymentHistoryData.payments) &&
    paymentHistoryData.payments.length > 0
  ) {
    const provider =
      paymentHistoryData.payments[paymentHistoryData.payments.length - 1].payment_provider;

    if (provider) {
      return provider;
    }
  }
  return defaultProvider;
}

export function mask(text, unmaskedLengthFromStart, maskChar = '*') {
  if (!text || text.length <= unmaskedLengthFromStart) {
    return text;
  }
  const atIndex = text.indexOf('@');

  const visible = Math.min(unmaskedLengthFromStart, atIndex);
  const initial = text.slice(0, visible)
  const repeat = maskChar.repeat(atIndex - visible)
  const last =  text.slice(atIndex);

  return initial + repeat + last;
}

export function getStripeAccount(source) {
  return config.default.clients[source].stripeAccount || 'toronto';
}



// WEBPACK FOOTER //
// ./src/helpers/common.js